<template>
  <div>
    <div :class="`${widgetIndex}-chart`" :ref="`${widgetIndex}-chart`" style="width: 100%; height: 340px;">
      <p class="loading__data" style="margin: 8px; text-align: center;">Loading...</p>
    </div>
    <div ref="detail" class="status--detail" style="width: 100%;">
      <ul>
        <li @click="toListMode(dt)" title="Click to see detail" v-for="(dt, index) in statusData"
          :key="index">
          <span :class="dt.className">{{ dt.status }}</span>
          <span :class="dt.className" class="pull-right">{{ dt.count }}</span>
        </li>
      </ul>
    </div>
    <transition name="slide-fade">
      <div ref="vehicle--list" v-show="listMode" class="vehicle--list">
        <div class="vehicle__list-header" :class="`${currentList.className}-header-list`">
          <p style="margin-bottom: 0px; font-weight: bold; color: white;" class="text-center">{{ currentList.status }} ({{ currentList.vehicles ? currentList.vehicles.length : 0  }})</p>
          <i title="Close" @click="listMode = false" class="fa fa-times-circle vehicle__list-close"></i>
        </div>
        <div ref="vehicle-list--container" class="vehicle-list--container">
          <ul>
            <li v-for="(vehicle, index) in currentList.vehicles"
              :key="index">{{ index + 1 }} - {{ vehicle.reg_no }}</li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import 'amcharts3';
import 'amcharts3/amcharts/pie';
import 'amcharts3/amcharts/plugins/animate/animate';
import 'amcharts3/amcharts/themes/light';

export default {
  name: 'vehicle-status',
  data() {
    return {
      timeout: null,
      statusData: [],
      currentList: [],
      listMode: false,
    };
  },
  props: {
    widgetIndex: {
      type: String,
      required: true,
    },
    geofences: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.createChart();
  },
  watch: {
    geofences() {
      clearTimeout(this.timeout);
      this.createChart();
    },
  },
  methods: {
    createChart: async function createChart() {
      setTimeout(() => {
        const idxRef = `${this.widgetIndex}-chart`;
        const chartElem = this.$refs[idxRef];

        this.setUpHeight();

        const chartConfig = {
          type: 'pie',
          fontFamily: "'Open Sans', sans-serif",
          theme: 'light',
          dataProvider: [],
          valueField: 'count',
          titleField: 'status',
          colorField: 'color',
          startDuration: 0,
          innerRadius: 50,
          pullOutRadius: 20,
          marginTop: 30,
          listeners: [{
            event: 'init',
            method: (e) => {
              const chartObj = e.chart;
              const loop = async () => {
                const data = await this.loadData();
                const prettifyData = this.prettifyData(data);
                this.statusData = prettifyData;

                chartObj.animateData(prettifyData, {
                  duration: 1e3,
                  complete: () => { this.reloadChartData(loop); },
                });
              };

              loop();
              this.removeChartTitleLink();
            },
          }],
        };

        window.AmCharts.makeChart(chartElem, chartConfig);
      }, 5e2);
    },
    loadData() {
      const locationIds = this.geofences.map(g => g.id);
      return this.$store.dispatch('vehicles/LOAD_VEHICLE_STATUS', locationIds);
    },
    reloadChartData(load) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        load();
      }, 5e3);
    },
    prettifyData(data) {
      const prettified = [];

      Object.keys(data).map((key) => {
        const statusText = key.replace(new RegExp('_', 'g'), ' ').toUpperCase();
        let bgColor = '';

        switch (key) {
          case 'available':
            bgColor = '#00A65A';
            break;
          case 'assigned':
            bgColor = '#F39C12';
            break;
          default:
            bgColor = '#F56954';
            break;
        }

        prettified.push({
          className: `${key}__status`,
          status: statusText,
          count: data[key].count,
          color: bgColor,
          vehicles: data[key].vehicles,
        });
        return key;
      });

      return prettified;
    },
    setUpHeight() {
      const idxRef = `${this.widgetIndex}-chart`;

      if (this.$refs[idxRef]) {
        const wItem = this.$parent.$refs.item || { clientHeight: 0 };
        const newHeight = wItem.clientHeight - 168;

        this.$refs[idxRef].style.height = `${newHeight}px`;
        this.$refs.detail.style.height = `${wItem.clientHeight - 343}px`;
        this.$refs['vehicle--list'].style.height = `${wItem.clientHeight - 43}px`;
        this.$refs['vehicle-list--container'].style.height = `${wItem.clientHeight - 73}px`;
      }
    },
    removeChartTitleLink() {
      const amChartTitle = document.querySelectorAll('a[title="JavaScript charts"]');
      for (let i = 0; i < amChartTitle.length; i++) {
        const chartTitle = amChartTitle[i];
        chartTitle.remove();
      }
    },
    toListMode(dt) {
      this.listMode = true;
      this.currentList = dt;
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
};
</script>
<style lang="sass" scoped>
  .slide-fade-enter-active
    transition: all .6s ease;

  .slide-fade-leave-active
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);

  .slide-fade-enter, .slide-fade-leave-to
    transform: translateY(-20px);
    opacity: 0;

  .status--detail > ul
    margin-bottom: 0px;
    list-style: none;
    padding-left: 0px;

  .status--detail > ul > li
    padding: 10px 15px;
    border-top: 1px solid #f4f4f4;
    cursor: pointer;

  .status--detail > ul > li:hover
    background: #f7f7f7;

  .assigned__status
    color: #F39C12;
    font-weight: bold;

  .assigned__status-header-list
    background: #F39C12;

  .available__status
    color: #00A65A;
    font-weight: bold;

  .available__status-header-list
    background: #00A65A;

  .on_duty__status
    color: #F56954;
    font-weight: bold;

  .on_duty__status-header-list
    background: #F56954;

  .vehicle--list
    width: 100%;
    position: absolute;
    top: 40px;
    background: white;

  .vehicle-list--container
    overflow-y: auto;

  .vehicle__list-close
    position: absolute;
    right: 5px;
    top: 8px;
    cursor: pointer;
    color: #fff;

  .vehicle__list-close:hover
    color: #d6d6d6;

  .vehicle__list-header
    height: 30px;
    padding: 4px;

  .vehicle-list--container > ul
    list-style: none;
    padding: 0px 8px 0px 8px;

  .vehicle-list--container > ul > li
    padding-top: 8px;
    border-bottom: 1px solid #7b7b7b;
</style>



// WEBPACK FOOTER //
// src/components/dashboard_widgets/VehicleStatus.vue